import React from "react";

const MarketPlaceInsights = ({category, type, selectedModule}) => {
  if (selectedModule === "bs") {
    if ((category === 6 && type === 1) || (category === 7 && type === 2) || (category === 11 && (type === 1 || type === 2 || type===7))
      || (category === 12 && type === 1)) {
      return (
        <div className="mt-3">
          <p>
            This feature is currently under development. However, you can still add accounts and grant user access by following the steps below.
          </p>

          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Steps to Add an Account:</h6>
            <p>1. Click on the <strong>Accounts</strong> tab.</p>
            <p>
              2. Click on{" "}
              {category === 6 && type === 1
                ? "Connect Kult AI (Text)"
                : category === 7 && type === 2
                ? "Connect Apollo"
                : category === 11 && type === 1
                ? "Connect G-Suite"
                : category === 11 && type === 2
                ? "Connect Outlook"
                : category === 12 && type === 1
                ? "Connect Valid Email"
                : "Connect / Add Account"}{" "}
              or Add Account to open the modal.
            </p>
            <p>
              3. Fill in all the required details and click <strong>Save</strong> to successfully add the account.
            </p>
          </div>

          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Steps to Grant User Access:</h6>
            <p className="mb-2">
              <span className="italic text-dark underline font-semibold">Note:</span>{" "}
              You can grant user access only after adding an account.
            </p>
            <p>1. Click on the <strong>Accounts</strong> tab.</p>
            <p>2. Click on the three dots (⋮) icon in the table.</p>
            <p>
              3. Click on <strong>Add Users</strong> to open the modal. Fill in all required details and click <strong>Submit</strong>.
            </p>
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="mt-3">
          <p>This feature is not available for Bench Sales. However, you can configure the following features:</p>
          <div className="ms-3">
            <h6 className="text-dark my-2 -ms-1">Available Features for Bench Sales:</h6>
            <p>1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt; Kult AI (Text) &gt; Setup / Configure</p>
            <p>2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt; Apollo &gt; Setup / Configure</p>
            <p>3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt; G-Suite &gt; Setup / Configure</p>
            <p>4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt; Outlook &gt; Setup / Configure</p>
            <p>5. <strong>Valid Email</strong> — Marketplace &gt; Email Verification &gt; Valid Email &gt; Setup / Configure</p>
          </div>
        </div>
      );
    }
  }
  return (
    <div className="mt-3">This feature is under development</div>
  );
};

export default MarketPlaceInsights;
